import React from "react";
import ResourcePage from "@/components/ResourcePage";

const STATUSES = ["DRAFT", "SENT", "VIEWED", "NEGOTIATION", "ACCEPTED", "REJECTED", "EXPIRED"];

export default function Quotations() {
  return (
    <ResourcePage
      title="Quotations" name="Quotation" endpoint="quotations"
      subtitle="Export quotations linked to buyer RFQs"
      emptyMessage="No quotations yet. Create a quotation from an RFQ to send pricing to your buyer."
      canExport relations={["buyers", "products"]}
      statusOptions={STATUSES}
      convert={{ endpoint: (id) => `quotations/${id}/convert-to-order`, to: "/orders", label: "To Order", toast: "Order created", resultKey: "order_number" }}
      columns={[
        { key: "quotation_number", label: "Quote No.", type: "mono" },
        { key: "buyer_name", label: "Buyer" },
        { key: "product_name", label: "Product" },
        { key: "total_value", label: "Total", type: "currency" },
        { key: "incoterms", label: "Incoterms" },
        { key: "status", label: "Status", type: "status" },
      ]}
      defaultValues={{ status: "DRAFT", currency: "INR", unit_price: 0, total_value: 0 }}
      formFields={[
        { name: "buyer_id", label: "Buyer", type: "relation", source: "buyers", required: true },
        { name: "product_id", label: "Product", type: "relation", source: "products" },
        { name: "quantity", label: "Quantity" },
        { name: "unit_price", label: "Unit price", type: "number" },
        { name: "currency", label: "Currency", type: "select", options: ["INR", "USD", "EUR", "GBP"] },
        { name: "total_value", label: "Total value (₹)", type: "number" },
        { name: "payment_terms", label: "Payment terms" },
        { name: "incoterms", label: "Incoterms", type: "select", options: ["FOB", "CIF", "CFR", "EXW", "DDP", "DAP"] },
        { name: "validity", label: "Validity" },
        { name: "delivery_terms", label: "Delivery terms" },
        { name: "expiry_date", label: "Expiry date", type: "date" },
        { name: "status", label: "Status", type: "select", options: STATUSES },
      ]}
    />
  );
}
